import { createContext, useContext } from 'react';
import { Property } from '@model';

export type QuickViewModel = {
  hideQuickViewModal: () => void;
  showQuickViewModal: (property: Property) => void;
  quickViewModalProperty: Property | undefined;
};

export const QuickViewContext = createContext<QuickViewModel>({
  hideQuickViewModal: () => {},
  showQuickViewModal: () => {},
  quickViewModalProperty: undefined,
});

export const useQuickView = () => useContext(QuickViewContext);
